// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"LiveChatModal_ContentWrapper__Mha1x","Title":"LiveChatModal_Title__1gasV","Text":"LiveChatModal_Text__1F7Fh"};